export const nl = {
  BestaatUit10DigitsTekst:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het veld moet 10 cijfers bevatten.",
  BevestigingEmail: "Wilt u een bevestiging op uw e-mailadres ontvangen?",
  BsnValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het burgerservicenummer bestaat uit 9 cijfers.",
  DateNotInFutureValidationFactoryText:
    "U heeft in het invulveld '{{label}}' een toekomstige datum ingevuld.",
  DateValidationFactoryValidationText: "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld.",
  FoldersAanvragenFormulier: "Aanvraagformulier folders",
  IsDecimalValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  IntegerValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  EmailAdres: "E-mailadres",
  EmailAdresControle: "Herhaal e-mailadres",
  EmailAdresInfoTxt: "Wij gebruiken dit e-mailadres als wij contact met u willen opnemen over uw bericht.",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "Er kunnen maximaal {{aantal}} tekens ingevoerd worden.",
  FoldersAanvragen: "Aanvraagformulier folders",
  FoldersEigenBijdrageWlz: "Eigen bijdrage {{jaar}} zorg vanuit de Wlz",
  FoldersEigenBijdrageWmo: "Eigen bijdrage {{jaar}} ondersteuning vanuit Wmo",
  FoldersEigenBijdrageWlzVorigJaar: "Eigen bijdrage {{vorigjaar}} zorg vanuit de Wlz",
  FoldersEigenBijdrageWmoVorigJaar: "Eigen bijdrage {{vorigjaar}} ondersteuning vanuit Wmo",
  FoutOphalenBenodigdeData: "Er is een fout opgetreden, probeer het later opnieuw.",
  GeboorteDatum: "Geboortedatum (dd-mm-jjjj)",
  IsDecimalValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het mag aleen cijfers bevatten.",
  IsKlantKaartDecimalValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het klantnummer mag maximaal 10 cijfers bevatten.",
  IsIbanValidationFactoryValidationText:
    "U heeft het invulveld {{label}} niet juist ingevuld, voorbeeld: NL01ABCD0123456789 (vervangen door uw eigen IBAN).",
  IsPostcodeValidationFactoryValidationText:
    "U heeft het invulveld {{label}} niet juist ingevuld, voorbeeld: 1234AA (vervangen door uw eigen postcode).",
  IsRequiredValidationFactoryValidationText: "U heeft het invulveld {{label}} niet ingevuld.",
  Ja: "Ja",
  Maximaal5BijlagenMaximaal5MBPerBijlage: "Maximaal 5 bijlagen, maximaal 5 MB per bijlage.",
  Nee: "Nee",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MinimumBedragInfoTxt:
    "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
  Omschrijving: "Omschrijving",
  Opmerkingen: "Opmerkingen",
  PersoonlijkeInformatie: "Persoonlijke informatie",
  StraatNaamHint: "Geen postbus of antwoordnummer",
  Telefoonnummer: "Telefoonnummer",
  Tussenvoegsels: "Tussenvoegsel(s)",
  Voorletters: "Voorletter(s)",
  VulUwGegevensIn: "Vul uw gegevens in",
  UBent: "U bent",
  VerlenerVanZorgOfHulpmiddelen: "Verlener van Zorg of Hulpmiddelen",
  Gemeente: "Gemeente",
  Pensioenverzekeraar: "Pensioenverzekeraar",
  SVB: "SVB",
  UWV: "UWV",
  Werkgever: "Werkgever",
  NaamVanUwOrganisatie: "Naam van uw organisatie",
  Aanhef: "Aanhef",
  Relatienummer: "Relatienummer",
  NaamVanContactpersoonBijHetCAK: "Naam van contactpersoon bij het CAK",
  RelatieNummerInfoTxt: "Dit nummer bestaat uit 6 cijfers.",
  OnverzekerbareVreemdelingen: "Onverzekerbare vreemdelingen",
  SubsidieregelingMedischNoodzakelijkeZorgAanOnverzekerden:
    "Subsidieregeling medisch noodzakelijke zorg aan onverzekerden",
  Kenmerk: "Kenmerk",
  KenmerkInfoTxt: "Dit nummer bestaat uit 10 cijfers.",
  OverWelkeRegelingGaatHet: "Over welke regeling gaat het?",
  RegelingBetalingsachterstandZorgpremie: "Betalingsachterstand zorgpremie",
  RegelingOnverzekerden: "Onverzekerden",
  IsRequiredValidationDefaultMessage: "U heeft het invulveld '{{label}}' niet ingevuld.",
  NaarOnzeHomepage: "Naar onze homepage"
};
